import ListingEnergyCertificate from './ListingEnergyCertificate';

export default ListingEnergyCertificate;
